/* Geo Gear Co: on desktop product pages the photo gallery stays in view while the right-hand column
   (lake name, set size, glass designs, add to cart) scrolls past it.
   The "Real photos" and "What customers say" blocks that sit under the gallery move to the end of the
   right-hand column on desktop, so the left column is only the gallery; on phones they go back. */
(function(){
  if(window.GGCStickyGallery) return; window.GGCStickyGallery=true;
  var imgCol=document.querySelector('.pr_sticky_img');
  var side=imgCol&&imgCol.querySelector('.theiaStickySidebar');
  var info=document.querySelector('.pr_sticky_su .theiaStickySidebar')||document.querySelector('.product-infors');
  if(!side||!info||!window.matchMedia) return;
  var root=document.documentElement, mq=window.matchMedia('(min-width:768px)'), SEL='.zdz-lifestyle-wrap, .ggc-rv', pend=0;
  var css=document.createElement('style');
  css.textContent='@media (min-width:768px){'+
    'html.ggc-stk #nt_wrapper{overflow:clip!important}'+
    'html.ggc-stk .pr_sticky_img>.theiaStickySidebar{position:sticky!important;top:var(--ggc-stk-top,24px)!important;left:auto!important;width:auto!important;transform:none!important;transition:top .2s ease}'+
    'html.ggc-stk .pr_sticky_su .zdz-lifestyle-wrap,html.ggc-stk .pr_sticky_su .ggc-rv{margin-top:28px}'+
  '}';
  document.head.appendChild(css);
  /* height of a fixed or sticky header at the top of the window, if one is showing */
  function headerBottom(){
    var b=0;
    try{
      var el=document.elementFromPoint(window.innerWidth-60,2);
      while(el&&el!==document.body){
        if(imgCol.contains(el)) break;
        var cs=getComputedStyle(el);
        if(cs.position==='fixed'||cs.position==='sticky'){ var r=el.getBoundingClientRect(); if(r.top<=2&&r.bottom<220) b=Math.round(r.bottom); break; }
        el=el.parentElement;
      }
    }catch(e){}
    return b;
  }
  function setTop(){
    pend=0;
    if(!mq.matches) return;
    var want=headerBottom()+24, h=side.getBoundingClientRect().height;
    /* a gallery taller than the window sticks with its bottom (thumbnails) in view */
    var top=Math.min(want, window.innerHeight-h-12);
    root.style.setProperty('--ggc-stk-top',top+'px');
  }
  function place(){
    var desk=mq.matches, bl=document.querySelectorAll(SEL);
    for(var i=0;i<bl.length;i++){
      var b=bl[i];
      if(desk&&side.contains(b)) info.appendChild(b);
      else if(!desk&&info.contains(b)) side.appendChild(b);
    }
    root.classList.toggle('ggc-stk',desk);
    setTop();
  }
  place();
  setTimeout(place,1500); setTimeout(place,4000);
  if(mq.addEventListener) mq.addEventListener('change',place); else if(mq.addListener) mq.addListener(place);
  window.addEventListener('resize',function(){ if(!pend) pend=requestAnimationFrame(setTop); });
  window.addEventListener('scroll',function(){ if(!pend) pend=requestAnimationFrame(setTop); },{passive:true});
})();
